import { useQuery } from '@tanstack/react-query'

import { getLoginOptions } from '@src/api'
import { DefaultApiGetLoginOptionsRequest } from '@src/api/generated/iam'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchLoginOptions = (
  params: DefaultApiGetLoginOptionsRequest
) => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })
  return useQuery({
    enabled: !!params.email && !!params.clientType,
    queryFn: () => getLoginOptions(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_LOGIN_OPTIONS, params],
    gcTime: Infinity,
  })
}
